import { Client } from '../../../store/clients/interfaces';

export const getClientFullName = (client: Client) => {
  const fullName = [client.firstName, client.lastName].filter(Boolean).join(' ').trim();
  return fullName || '-';
};

export const getClientInitial = (client: Client) => {
  const initial = client.firstName?.[0] || client.lastName?.[0] || '?';
  return initial.toUpperCase();
};

export const getClientStatus = (client: Client) => (client.status || 'NEW').toUpperCase();

export const formatTransactedAmount = (amount?: number, currency?: string, emptyValue = '-') => {
  if (amount == null || Number.isNaN(Number(amount))) {
    return emptyValue;
  }

  const formatted = Math.round(Number(amount)).toLocaleString('es-AR', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  return `${currency || ''} ${formatted}`.trim();
};

export const formatTransactedAmountValue = (amount?: number) => {
  if (amount == null || Number.isNaN(Number(amount))) {
    return '0';
  }

  return Math.round(Number(amount)).toLocaleString('es-AR', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
};
